"use client";
import Image from "next/image";
import Button from "./Button";
import { useLocale } from "next-intl";
import { Link, useRouter } from "../../../navigation";

const RecentThemeCard = ({
  className,
  imagePath,
  title,
  theme,
  description,
  buttonLink,
  buttonText,
  isImageLeft,
}: {
  className: string;
  imagePath?: string;
  title: string;
  theme: string;
  description: string;
  buttonLink: string;
  buttonText: string;
  isImageLeft?: boolean;
}) => {
  const locale = useLocale();
  const router = useRouter();

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (buttonLink) router.push(buttonLink);
  };
  return (
    <Link
      href={buttonLink || ""}
      lang={locale}
      data-image-left={isImageLeft}
      className={`recent-themes-card border-radius overflow-hidden drop-shadow ${className || ""}`}
    >
      {imagePath && (
        <Image
          className="recent-themes-card__image"
          src={imagePath}
          alt=""
          quality={80}
          width={910}
          height={910}
          unoptimized={imagePath.endsWith(".svg")}
          style={{ objectFit: "cover", objectPosition: "center" }}
        />
      )}
      <div className="recent-themes-card__content">
        <div className="theme">{theme}</div>
        <h4 className="title mb-0 regular-serif line-clamp-2">{title}</h4>
        <p className="mb-0 line-clamp-4">{description}</p>
        <Button appearance="secondary" onClick={handleButtonClick}>
          {buttonText}
        </Button>
      </div>
    </Link>
  );
};

export default RecentThemeCard;
